export default {
  "brand.name": "USFansLink",
  "nav.home": "Strona główna",
  "nav.guide": "Przewodnik po arkuszu",
  "nav.shopping": "Przewodnik zakupowy",
  "nav.categories": "Kategorie",
  "nav.visit": "Odwiedź stronę główną",
  "lang.en": "English",
  "lang.pl": "Polski",
  "lang.es": "Español",
  "lang.fr": "Français",
  "footer.tagline": "Niezależne centrum zasobów arkusza USFans.",
  "footer.navTitle": "Odkrywaj",
  "footer.resourcesTitle": "Zasoby",
  "footer.disclaimerTitle": "Zastrzeżenie",
  "footer.disclaimer": "USFansLink.asia to niezależny serwis informacyjny. Nie jesteśmy powiązani z USFans ani ze stroną główną. Zawsze weryfikuj aktualne informacje przed dokonaniem zakupu lub płatności.",
  "footer.home": "Strona główna",
  "footer.guide": "Przewodnik po arkuszu",
  "footer.mainSite": "Strona główna serwisu",
  "footer.copyright": "© 2026 USFansLink.asia. Wszelkie prawa zastrzeżone.",
  "notfound.title": "Nie znaleziono strony",
  "notfound.body": "Strona, której szukasz, nie istnieje lub została przeniesiona.",
  "notfound.home": "Wróć na stronę główną",
};